




































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
  },
  name: "AddSignatureForm"
})
export default class AddSignatureForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @surveys.Getter('stateCurrentSurvey') protected stateCurrentSurvey:any

  other:boolean = false
  signature:any = {
    answerTitle: '',
    answers: [],
    text: '',
    type: 'text_container',
    order: 777777777,
    help: '',
    specify: 'default'
  }

  @Watch('fullDialogShow')
  setSignature() {
    if(!this.fullDialogShow) {
      this.signature = {
        answerTitle: '',
        answers: [],
        text: '',
        type: 'text_container',
        order: 777777777,
        help: '',
        specify: 'default'
      }
    }
  }

  save() {
    this.signature.isNew = true
    this.stateCurrentSurvey.survey.questions.push(this.signature)
    this.SetFullDialogShow(false)
  }
  

}
